import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Button } from "../components/ui/button";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_chauffage-pac/artifacts/kjcz0m09_ChatGPT%20Image%2011%20fe%CC%81vr.%202026%20a%CC%80%2019_18_47%20%281%29.png";

export default function SEOHeader() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "bg-white/95 backdrop-blur-md shadow-md" : "bg-white shadow-sm"}`} style={{ WebkitBackfaceVisibility: "hidden" }}>
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex items-center justify-between h-14 md:h-18">
          <a href="/" className="flex items-center gap-2 flex-shrink-0">
            <img src={LOGO_URL} alt="ALTER ENERGIES" className="h-9 md:h-12 w-auto" />
          </a>
          <div className="flex items-center gap-3">
            <a href="#devis" className="hidden sm:inline-flex items-center text-sm font-semibold text-[#6AB023] hover:text-[#5a9a1e] transition-colors">Devis gratuit →</a>
            <a href="tel:0628514915">
              <Button className="bg-[#6AB023] hover:bg-[#5a9a1e] text-white font-semibold rounded-full px-4 md:px-6 h-9 md:h-10 gap-1.5 md:gap-2 text-xs md:text-sm">
                <Phone className="w-3.5 h-3.5 md:w-4 md:h-4" />
                <span className="hidden sm:inline">06 28 51 49 15</span>
                <span className="sm:hidden">Appeler</span>
              </Button>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
